import { creatorbase } from '@round/api';

export const timeSeriesFieldLabels: Record<creatorbase.TimeSeriesField, string> = {
    tiktok_daily_change: 'TikTok Daily Creations',
    tiktok_daily_totals: 'TikTok Total Creations',
    instagram_daily_change: 'Instagram Daily Creations',
    instagram_daily_totals: 'Instagram Total Creations',
    posts_daily_change: 'Daily Posts',
};
